module.exports = __webpack_public_path__ + "img/menu_bottom_11.1124fb32.svg";